const throbberCls = "_uihtdpa6o6";

export { throbberCls };
import "./atom.throbber.style.linaria.module.css";
//# sourceMappingURL=atom.throbber.style.js.map
